import { Reveal } from "@components/ui";

const contactCards = [
  {
    color: "#f03813",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    label: "Hotline",
    value: "800-GASIS (42747)",
    desc: "24/7 Emergency & Customer Service",
  },
  {
    color: "#1a7a4f",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    label: "WhatsApp",
    value: "+971 5 XXX XXXX",
    desc: "8 AM – 8 PM Daily",
  },
  {
    color: "#122d63",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22 6l-10 7L2 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    label: "Email",
    value: "help@gasis.ae",
    desc: "Replies within 24 hours",
  },
  {
    color: "#6b4fc7",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
        <rect x="3" y="4" width="18" height="18" rx="2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 2v4M8 2v4M3 10h18" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    label: "Book a Callback",
    value: "Schedule via form",
    desc: "Sun – Thu, 8 AM – 6 PM",
  },
  {
    color: "#d4880f",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    label: "Live Chat",
    value: "Website or mobile app",
    desc: "Business hours",
  },
];

export default function ContactOptionsSection() {
  return (
    <section className="w-full bg-white pt-[40px] md:pt-[60px] pb-10 md:pb-14 lg:pb-[80px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto font-albert-sans">
        {/* Header */}
        <Reveal direction="up" className="text-center mb-8 md:mb-10">
          <h2 className="text-[28px] md:text-[36px] lg:text-[44px] font-semibold text-[#122d63] tracking-[-0.04em] leading-tight">
            Contact Options
          </h2>
          <p className="text-[16px] md:text-[20px] text-[#62636c] mt-2 md:mt-3">
            Choose the channel that works best for you.
          </p>
        </Reveal>

        {/* Compact horizontal cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {contactCards.map((card, index) => (
            <Reveal key={card.label} direction="up" delay={index * 60} className="h-full">
              <div className="h-full rounded-[16px] border border-[rgba(98,99,108,0.15)] bg-white p-4 md:p-5 flex flex-col items-center text-center gap-2.5 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300">
                <div
                  className="w-11 h-11 rounded-[10px] flex items-center justify-center shrink-0"
                  style={{ backgroundColor: card.color }}
                >
                  {card.icon}
                </div>
                <span className="text-[13px] text-[#62636c] font-medium uppercase tracking-wider">
                  {card.label}
                </span>
                <span className="text-[16px] md:text-[18px] font-semibold text-[#090d2c] leading-tight">
                  {card.value}
                </span>
                <span className="text-[13px] md:text-[14px] text-[#62636c]">
                  {card.desc}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
